import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import api from '../../api/endpoints';
import { handleErrors, fetch } from '../../api';

function* getStripeBilling({ payload: { onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.stripeBilling });

    if (onSuccess) {
      onSuccess(data.result.url);
    }

    yield put(actions.getStripeBillingDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getStripeBillingFailed,
      endpoint: api.stripeBilling.url
    });
  }
}

export const getStripeBillingSaga = takeEvery(types.GET_STRIPE_BILLING_REQUEST, getStripeBilling);